import { render, staticRenderFns } from "./app-upload.vue?vue&type=template&id=2184396c"
import script from "./app-upload.vue?vue&type=script&lang=js"
export * from "./app-upload.vue?vue&type=script&lang=js"
import style0 from "./app-upload.vue?vue&type=style&index=0&id=2184396c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports